import React from "react";
import { useHistory } from "react-router-dom";
import { isZh } from "../../utils/language";

export default function PreRegToolbar({
  agendaList,
  selectedAgenda,
  setSelectedAgenda,
  search,
  setSearch,
  filters,
  setFilters,
  filtered,
  canWrite,
}) {
  const history = useHistory();

  function toggleFilter(group, value) {
    setFilters((prev) => {
      const exists = prev[group].includes(value);

      return {
        ...prev,
        [group]: exists
          ? prev[group].filter((x) => x !== value)
          : [...prev[group], value],
      };
    });
  }

  return (
    <div className="prereg-toolbar">

      <select
        className="prereg-input"
        value={selectedAgenda || ""}
        onChange={(e) =>
          setSelectedAgenda(e.target.value)
        }
      >

        <option value="">
          {isZh()
            ? "請選擇活動"
            : "Pilih Agenda"}
        </option>

        {agendaList.map((agenda) => (

          <option
            key={agenda.documentId}
            value={agenda.documentId}
          >

            {isZh()
              ? (
                agenda.subject_zh ||
                agenda.subject
              )
              : agenda.subject}

          </option>

        ))}

      </select>

      <input
        type="search"
        className="prereg-input"
        placeholder={
          isZh()
            ? "搜尋姓名 / 電話"
            : "Cari nama / no telp"
        }
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="prereg-chip-wrap">

        <button
          className={`prereg-chip ${
            filters.status.includes("confirmed")
              ? "active"
              : ""
          }`}
          onClick={() =>
            toggleFilter("status", "confirmed")
          }
        >
          {isZh() ? "已確認" : "Terkonfirmasi"}
        </button>

        <button
          className={`prereg-chip ${
            filters.personType.includes("Internal")
              ? "active"
              : ""
          }`}
          onClick={() =>
            toggleFilter("personType", "Internal")
          }
        >
          {isZh() ? "內部" : "Internal"}
        </button>

      </div>

      <div className="prereg-toolbar-actions">

        <button className="prereg-btn secondary">
          ⭳ {isZh() ? "匯出" : "Export"}
        </button>

        <button className="prereg-btn secondary">
          📊 {isZh() ? "統計" : "Statistik"}
        </button>

      </div>

      <div className="prereg-mini-stats">
        <div>
          {isZh() ? "總數" : "Total"}:
          <strong> {filtered.length}</strong>
        </div>
      </div>

    </div>
  );
}